module.exports = __webpack_public_path__ + "static/media/nvot.eed2f373.png";